import store from '@/store/index';
import DownLoadNative from '@/utils/downLoadNative'
import DomainPool from '@/utils/domainPool'
import Message from '@/packages/message/index.js';
import Toast from '@/packages/toast/index.js';
import {
    getParams,
    initApp,
    initConfig
} from './common';
import {
    getVersion,
    ping,
    getNewestDomainPool
} from '@/api/task'
let _serverType, _downloadUrl, _version;

//获取AppInfo的回调
const getAppInfoCallback = function(e) {
    const data = JSON.parse(e);
    const version = String(data.appVersion).split('.').join(''),
        token = data.token,
        isSetPwd = data.isSetPwd,
        isLogin = data.isLogin,
        userId = data.userId,
        env = data.env,
        pool = (data.domainPool && data.domainPool.split('|')) || DomainPool.getCurrentPool(env),
        iframeVersion = data.iframeVersion;
    let userInfo = {
        userId: userId,
        token: token
    }
    const envStr = env == 'dis' ? 'build' : env;
    store.dispatch("setAppVersion", `App ${envStr}-${data.appVersion}`);
    checkDomain(0, pool).then((domain) => {
        store.dispatch("setDomain", `gw.${domain}`);
        getDomainPoolFromServer();
        store.dispatch("setIsSetPwd", isSetPwd);
        window.nativeUtils.getData('nickname').then(nickname => {
            userInfo.nickname = nickname;
            store.dispatch("setUserInfo", userInfo);
        })

        //登录过刷新页面，直接进
        if (isLogin == 1) {
            store.dispatch("setShowScanUI", false);
            loadApp();
        } else {
            checkAppVersion(version, isSetPwd, token, iframeVersion);
        }
    })
}

//从服务端获取最新的域名池
function getDomainPoolFromServer() {
    getNewestDomainPool().then((res) => {
        res = res.data;
        if (res.code == 0) {
            const domainPool = res.result.domain_pool;
            window.nativeUtils.setData('domainPool', domainPool.join('|'));
        }
    })
}

//检查域名池是否可用
function checkDomain(index, pool) {
    return new Promise((resolve, reject) => {
        if (pool.length > 0) {
            ping(pool[index]).then(() => {
                resolve(pool[index]);
            }).catch(() => {
                index++;
                if (index >= pool.length) {
                    Toast.service('没有可用域名，请重新下载APP');
                } else {
                    checkDomain(index, pool);
                }
                reject('没有可用域名，请重新下载APP')
            })
        } else {
            Toast.service('没有可用域名，请重新下载APP');
            reject('没有可用域名，请重新下载APP')
        }
    });
}

//检查App版本
function checkAppVersion(version, isSetPwd, token, iframeVersion) {
    const params = {
        platform: store.state.app.platform == 1 ? 'ios' : 'android'
    };
    getVersion(params).then(res => {
        res = res.data;
        if (window.__loading) {
            window.__loading.close();
            window.__loading = null;
        }
        if (res.code == 0) {
            const server_ver = String(res.result.app_version.version).split('.').join(''),
                iframeServerVer = String(res.result.iframe_version.version),
                formatIframeServerVer = iframeServerVer.split('.').join(''),
                iframeDownloadUrl = String(res.result.iframe_version.download_url);
            //先判断APP的版本，版本小于最新版本，更新版本
            if (version < server_ver) {
                //强制更新                            
                if (res.result.app_version.update_type == 1) {
                    Message.service({
                        content: '发现新版本，是否立即更新？',
                        confirmText: '立即更新',
                        confirmClose: false,
                        confirmCallback: () => {
                            window.nativeUtils.openURL(res.result.app_version.download_url);
                        }
                    })
                } else {
                    Message.service({
                        content: '发现新版本，是否立即更新？',
                        confirmText: '立即更新',
                        confirmClose: false,
                        confirmCallback: () => {
                            window.nativeUtils.openURL(res.result.app_version.download_url);
                        },
                        showCloseBtn: true,
                        closeCallback: () => {
                            store.dispatch("setShowScanUI", true);
                            //token 存在且设置过密码，显示手势密码界面
                            if (token && isSetPwd == 1) {
                                store.dispatch("setScanUiType", 2);
                            }
                            //token 不存在，显示扫描提示界面
                            else {
                                store.dispatch("setScanUiType", 1);
                            }
                        }
                    })
                }
            } else {
                checkIframeVersion(iframeVersion, iframeServerVer, formatIframeServerVer, iframeDownloadUrl, token, isSetPwd);
            }
        }
    })
}

//检查壳的版本
function checkIframeVersion(iframeVersion, iframeServerVer, formatIframeServerVer, iframeDownloadUrl, token, isSetPwd) {
    if (!iframeVersion) {
        //下载
        downLoadIframe(999, iframeDownloadUrl, iframeServerVer, '正在下载资源文件中');
    } else if (iframeVersion && parseInt(iframeVersion.split('.').join('')) < parseInt(formatIframeServerVer)) {
        //更新壳
        downLoadIframe(999, iframeDownloadUrl, iframeServerVer, '正在更新资源文件中');
    } else {
        store.dispatch("setShowScanUI", true);
        //token 存在且设置过密码，显示手势密码界面
        if (token && isSetPwd == 1) {
            store.dispatch("setScanUiType", 2);
        }
        //token 不存在，显示扫描提示界面
        else {
            store.dispatch("setScanUiType", 1);
        }
    }
}

//实例化下载壳的方法
function downLoadIframe(serverType, downloadUrl, version, txt) {
    new DownLoadNative(serverType, downloadUrl, version, true, function() {
        window.nativeUtils.setData('iframeVersion', version);
        window.location.reload();
    }).init(txt);
}

//进入App
function loadApp(serverType) {
    initApp(serverType).then(res => {
        initHall(res.server_type, res.download_url, res.version)
    })
    initConfig();
}

//获取游戏信息的回调
const getGameInfoCallback = function(e) {
    if (e) {
        const gameInfo = JSON.parse(e);
        const formatVersion = String(_version).split('.').join('');
        if (!gameInfo.version) {
            // 不存在version,下载
            downLoadHall('正在下载游戏包中');
        } else if (gameInfo.version && parseInt(String(gameInfo.version).split('.').join('')) < parseInt(formatVersion)) {
            // 存在小version,更新
            downLoadHall('正在更新游戏包中');
        } else {
            readyHall(gameInfo.native_url);
        }
    } else {
        downLoadHall('正在下载游戏包中');
    }
}

//实例化下载大厅的方法
function downLoadHall(txt) {
    new DownLoadNative(_serverType, _downloadUrl, _version, true, function(u) {
        readyHall(u);
    }).init(txt);
}

//给大厅赋值
function readyHall(url) {
    const iframeUrl = `${url}?${getParams()}&v=${new Date().getTime()}`;
    store.dispatch("setHallIfmUrl", iframeUrl);
}

//初始化APP大厅
function initHall(serverType, downloadUrl, version) {
    _serverType = serverType;
    _downloadUrl = downloadUrl;
    _version = version;
    window.nativeUtils.getGameInfo(serverType).then((e) => {
        getGameInfoCallback(e)
    })
}

function getAppInfo() {
    window.nativeUtils.getAppInfo().then((e) => {
        getAppInfoCallback(e)
    })
}

class Native {
    constructor() {}
    init() {
        getAppInfo();
    }
    loadApp() {
        loadApp(1000)
    }
}

export default Native;